export default __webpack_public_path__ + "static/media/buddy_magnet_3.c143a740.png";